<template>
  <div>
    <VueApexCharts
      :options="seasonalChart.options"
      :series="props.seriesData"
      height="350"
    ></VueApexCharts>
  </div>
</template>

<script setup>
import { reactive, defineProps } from "vue";
import VueApexCharts from "vue3-apexcharts";

const props = defineProps({
  seriesData: {
    type: Array,
    required: false,
    default: () => []
  },
  // categories: {
  //   type: Array,
  //   required: false,
  // },
})

// * Bar Chart data
const seasonalChart = reactive({
  series: [
    {
      name: "Daily Total",
      data: [
        Math.floor(Math.random() * (300 + 1) + 100),
        Math.floor(Math.random() * (300 + 1) + 100),
        Math.floor(Math.random() * (300 + 1) + 100),
        Math.floor(Math.random() * (300 + 1) + 100),
      ],
    },
  ],

  options: {
    chart: {
      height: 350,
      type: "area",
      toolbar: {
        show: true,
      },
    },
    stroke: {
      curve: "smooth",
      width: 2.5,
    },
    colors: ["#0c1e36", "#2B978D"],
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.25,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    // labels: ['Dec 01', 'Dec 02', 'Dec 03', 'Dec 04', 'Dec 05', 'Dec 06', 'Dec 07', 'Dec 08', 'Dec 09 ', 'Dec 10', 'Dec 11'],
    markers: {
      size: 0,
    },
    yaxis: {
      labels: {
        show: true,
        formatter: function (val) {
          return val + " kWh";
        },
      },
    },
    // tooltip: {
    //   shared: true,
    //   intersect: false,
    // }
  },
});
</script>
